"use client";

import { useState, useEffect } from 'react';
import { screenSizes } from "@/utils/tailwind";

type Breakpoint = 'mobile' | 'tablet' | 'desktop';

export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>('mobile');

  useEffect(() => {
    const checkBreakpoint = () => {
      if (window.innerWidth >= screenSizes.lg) {
        setBreakpoint('desktop');
    //   } else if (window.innerWidth >= screenSizes.md) {
    //     setBreakpoint('tablet');
      } else {
        setBreakpoint('mobile');
      }
    };

    checkBreakpoint();
    window.addEventListener('resize', checkBreakpoint);
    return () => window.removeEventListener('resize', checkBreakpoint);
  }, []);

  return breakpoint;
}; 